import { CHANNEL_TYPE } from "vue-app/types/enums";
import { byteLength } from "vue-app/utils/functions";

export default {
  getEditor: (state) => state.editor,
  messageSubject: (state) => state.message.subject,
  messagePreheader: (state) => state.message.preheader,
  messageHtml: (state) => state.message.html,
  messageDesign: (state) => state.message.design,
  messageLanguage: (state) => state.messageLanguage,
  engagement: (state) => state.engagement,
  engagementLanguages: (state) => state.engagementLanguages,
  isChannelSelectorVisible: (state) => state.availableChannelTypes.length > 1,
  isSubjectEmpty: (state) => state.isMessageModified && state.message.subject === "",
  canPasteMessage: (state) => state.messageClipboard && state.messageClipboard.hasData,
  canUndoMessage: (state) => state.editorType === CHANNEL_TYPE.EMAIL && state.messageHistory.length > 0,
  areTemplatesAvailable: (state) => state.templates.length > 0,
  isNewMessageLoading: (state) => state.isNewMessageLoading,
};
